import BackofficeApplicationRegistry from "components/BackofficeApplicationRegistry";

export default function ApplicationRegistry(): JSX.Element {
	return <BackofficeApplicationRegistry />;
}
